import { InjectionToken } from '@angular/core';

export const ERP_API_URL = new InjectionToken<string>('ERP_API_URL');

/** Normaliza el origen público y asegura el prefijo `/api/erp`. */
export function resolveErpApiUrl(configuredUrl: string): string {
  const normalized = configuredUrl.replace(/\/+$/, '');
  return normalized.endsWith('/api/erp')
    ? normalized
    : `${normalized}/api/erp`;
}
